
import {
  Component,
  Vue,
  Prop,
} from 'vue-property-decorator';
import moment from 'moment';
import { getAiStoreInfoList } from '@/api/storeInfo';
import {
  getLat,
  getLng,
  setLat,
  setLng,
} from '@/utils/cookies';

@Component({
  name: 'Calendar',
})
export default class extends Vue {
  @Prop({ required: true }) private lat!: any;

  @Prop({ required: true }) private lng!: any;

  @Prop({ required: false, default: 0 }) private stayCnt!: number;

  @Prop({ required: false, default: 0 }) private restaurantCnt!: number;

  @Prop({ required: false, default: 0 }) private placeCnt!: number;

  @Prop({ required: false, default: 0 }) private leisureCnt!: number;

  @Prop({ required: false, default: false }) private currentLocationFlag!: any;

  @Prop({ required: false, default: moment().format('YYYY-MM-DD') }) private startDate!: any;

  @Prop({ required: false, default: moment().add(1, 'days').format('YYYY-MM-DD') }) private endDate!: any;

  @Prop({ required: false, default: 2 }) private people!: any;

  mounted() {
    this.getAiItemList();
  }

  private aiSearchLoading = true;

  private apiUrl = process.env.VUE_APP_COMMON_API;

  private now = moment().format('YYYY-MM-DD');

  private aiItem: any = {
    stayList: [],
    restaurantList: [],
    placeList: [],
    leisureList: [],
    productList: [],
  }

  private totalSearchQuery = {
    page: 0,
    size: 2,
    lat: this.lat,
    lng: this.lng,
    stayCnt: this.stayCnt,
    restaurantCnt: this.restaurantCnt,
    placeCnt: this.placeCnt,
    leisureCnt: this.leisureCnt,
    orderType: 'distance',
    randomRange: 5,
  };

  private getAiItemList() {
    if (this.currentLocationFlag) {
      const lat = getLat();
      const lng = getLng();
      if (lat && lng) {
        this.totalSearchQuery.lat = lat;
        this.totalSearchQuery.lng = lng;
      } else {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.totalSearchQuery = {
              ...this.totalSearchQuery,
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };
            setLat(position.coords.latitude);
            setLng(position.coords.longitude);
          },
        );
      }
    } else {
      this.totalSearchQuery.lat = this.lat;
      this.totalSearchQuery.lng = this.lng;
    }
    this.getAiStoreInfoList();
  }

  private getAiStoreInfoList() {
    this.aiSearchLoading = true;
    getAiStoreInfoList(this.totalSearchQuery).then((res) => {
      this.aiItem = {
        ...this.aiItem,
        ...res.data,
      };
    });
    this.aiSearchLoading = false;
  }

  private handleItemClick(idx: any, type: any) {
    if (type === 1) { // 숙소
      this.$router.push({ name: 'StayDetail', params: { stayIdx: idx } });
    } else if (type === 3) { // 레저 / 체험
      this.$router.push({ name: 'LeisureView', params: { idx } });
    } else if (type === 4) { // 외식
      this.$router.push({ name: 'RestaurantView', params: { idx } });
    } else if (type === 6) { // 관광
      this.$router.push({ name: 'PlaceView', params: { idx } });
    }
  }
}
